export const DAYS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];

export const DAYS_FULL = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

